// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__wMier","page":"App_page__DDHbQ","skip":"App_skip__7_R_3"};